import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {NavService} from '../../service/nav.service';
import {Router} from '@angular/router';
import {ApiModulesService} from 'src/app/api-modules.service';
import {onlinestores} from 'src/app/components/onlinestores/onlinestores.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
    role: any = localStorage.getItem('role');
    public right_sidebar: boolean = false;
    public open: boolean = false;
    public openNav: boolean = false;
    public isOpenMobile: boolean;
    public countryname = [];
    selected_country: any = localStorage.getItem('country_id');
    country_code: any = localStorage.getItem('country_code');

    public rows = [];
    public srch = [];
    @Output() rightSidebarEvent = new EventEmitter<boolean>();
    menus: any;

    constructor(private apiModulesService: ApiModulesService,
                public navServices: NavService, private router: Router, private onlineservice: onlinestores) {
        this.onlineservice.raiseDataEmitterEvent(this.selected_country);
    }

    collapseSidebar() {
        this.open = !this.open;
        this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
    }

    right_side_bar() {
        this.right_sidebar = !this.right_sidebar;
        this.rightSidebarEvent.emit(this.right_sidebar);
    }

    openMobileNav() {
        this.openNav = !this.openNav;
    }

    Logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        // localStorage.clear()

        this.router.navigate(['/login']);
    }


    ngOnInit() {
        this.getCountriesName();
        this.searchRegionName();
    }


    public getCountriesName() {
        this.apiModulesService.get('telegram/country/list').subscribe((data) => {
            this.countryname = data;
        });
    }

    searchRegionName() {
        let any: any = this.countryname;
        this.country_code = this.countryname.find(value => value.id == this.selected_country);
        localStorage.removeItem('country_id');
        localStorage.removeItem('country_code');
        localStorage.setItem('country_id', this.selected_country);
        localStorage.setItem('country_code', this.country_code?.country_code);
        this.onlineservice.raiseDataEmitterEvent(this.selected_country);
        let params: any = {};
        params.country_id = this.selected_country;
        this.apiModulesService.add(params, 'stores').subscribe((data) => {
            this.menus = data;
        });
    }
}
